module.exports = __webpack_public_path__ + "img/anel.f3527afe.png";